import { ClipLoader } from 'react-spinners'
import { TABLET_SIZE } from '../../../../core/constants/common'
import { useWindowSize } from '../../../../core/hooks/common/useWindowSize'
import ModalLayout from '../../../layout/main/ModalLayout'
import Text from '../../../../core/utils/Text'
import CoinSelect from '../../../common/input/CoinSelect'
import { useEffect, useMemo, useState } from 'react'
import { Background } from '../../../../styles/CommonStyles'
import Input from '../../../common/input/Input'
import Select from '../../../common/dropdown/Select'
import { deepCopy, stringToNumber, uuidv4 } from '../../../../core/utils/common'
import { FaEdit, FaTrash } from 'react-icons/fa'
import CheckBox from '../../../common/input/CheckBox'
import { useAvailableCoins } from '../../../../core/services/react-query/setting'
// import { useAvailableCoins } from '../../../../core/services/react-query/setting'

const fieldTypes = ['string', 'number', 'boolean', 'date', 'user.account', 'owner.account', 'file']
const typeColors = {
	string: 'bg-green-500/30',
	number: 'bg-blue-500/30',
	date: 'bg-yellow-500/30',
	boolean: 'bg-cyan-500/30',
	'user.account': 'bg-purple-500/30',
	'owner.account': 'bg-orange-500/30',
}

const AccountingModal = ({ details, onClose, mutate, loading, cache }) => {
	const { width, height } = useWindowSize()
	// const { data: availableCoins } = useAvailableCoins()

	// const coins = useMemo(() => {
	// 	if (!cache || !availableCoins || !details.type) return []
	// 	const cacheIds = cache[details.type]?.map((x) => x.currency)
	// 	let res = []
	// 	for (const c of availableCoins) {
	// 		if (!cacheIds.includes(c.id)) res.push(c)
	// 	}
	// 	if (!cacheIds.includes('irt')) {
	// 		res.push({
	// 			id: 'irt',
	// 			name: 'Tooman',
	// 			fa: 'تومان',
	// 		})
	// 	}
	// 	return res
	// }, [availableCoins, cache, details])

	const initialInput = {
		name: '',
		currency: null,
		min: '',
		max: '',
		feeMin: '',
		feeMax: '',
		feeFactor: '',
		fields: [],
		isError: '',
		errorMessage: '',
		errorKey: '',
	}
	const [input, setInput] = useState(initialInput)
	const onInputChange = (v, t) => {
		setInput((state) => ({ ...state, [t]: v }))
	}

	const isUpdate = details.idx > -1
	const type = details.type

	const checkError = () => {
		const keys = Object.keys(input)
		for (let i = 0; i < keys.length; i++) {
			const k = keys[i]
			const v = input[k]
			if (k === 'isError' || k === 'errorMessage' || k === 'errorKey') continue
			if ((k === 'fields' && !v.length) || !v) {
				setInput((state) => ({
					...state,
					isError: true,
					errorMessage: `${k}-is-required`,
					errorKey: k,
				}))
				return false
			}
		}
		return true
	}

	const onAddAccounting = () => {
		const res = checkError()
		if (res) {
			const newAccountings = deepCopy(cache)
			const payload = {
				currency: input.currency.id,
				min: stringToNumber(input.min),
				max: stringToNumber(input.max),
				feeMin: stringToNumber(input.feeMin),
				feeMax: stringToNumber(input.feeMax),
				feeFactor: stringToNumber(input.feeFactor),
				fields: input.fields,
				name: input.name,
			}
			if (isUpdate) {
				newAccountings[type][details.idx] = payload
			} else {
				newAccountings[type].push(payload)
			}

			mutate(newAccountings)
		}
	}

	const initialFieldValues = {
		type: '',
		name: '',
		description: '',
		isRequired: false,
	}
	const initialFieldMode = { mode: 'close', data: null, idx: -1 }
	const [fieldValues, setFieldValues] = useState(initialFieldValues)
	const [fieldMode, setFieldMode] = useState(initialFieldMode)

	const onChangeOrAddField = () => {
		const newFields = deepCopy(input.fields)
		const randomId = uuidv4()

		if (fieldMode.mode === 'add') newFields.push({ ...fieldValues, id: randomId })
		else newFields[fieldMode.idx] = fieldValues
		setInput((state) => ({
			...state,
			fields: newFields,
		}))
		setFieldMode(initialFieldMode)
		setFieldValues(initialFieldValues)
	}

	const onDeleteField = (idx) => {
		const newFields = deepCopy(input.fields)
		newFields.splice(idx, 1)
		setInput((state) => ({
			...state,
			fields: newFields,
		}))
	}

	useEffect(() => {
		if (input.isError && input.errorKey === 'fields' && input.fields.length > 0) {
			setInput((state) => ({ ...state, isError: false, errorMessage: '', errorKey: '' }))
			return
		}
		if (input.isError && input.errorKey !== 'fields' && input[input.errorKey]) {
			setInput((state) => ({ ...state, isError: false, errorMessage: '', errorKey: '' }))
		}
	}, [input])

	const { data: availableCoins } = useAvailableCoins()
	useEffect(() => {
		if (!!details?.data && !!availableCoins) {
			const currency = availableCoins.find((x) => x.id === details.data.currency)
			if (!!currency) {
				setInput({
					...details.data,
					currency,
				})
			}
		}
	}, [details, availableCoins])

	return (
		<ModalLayout open={details.open} width={'700px'} padding={'0'} isStatic={width > TABLET_SIZE}>
			<div className={`relative dark:text-gray-300 text-sm`}>
				<div
					className={`overflow-y-auto overflow-x-hidden`}
					style={{ maxHeight: `${(height * 80) / 100}px` }}
				>
					<div className={'px-3 py-3 w-full rounded-t-md dark:bg-cardBg'}>
						<Text tid={`${isUpdate ? 'update' : 'add'}-accounting-${type}`} />
					</div>

					<div className={'w-full flex flex-col gap-2 p-3'}>
						<div className={'flex flex-col gap-1 lg:col-span-2 px-1'}>
							<Text tid={'coin'} className={'mx-1'} />
							<CoinSelect
								// predefined={coins}
								value={input.currency}
								onChange={(v) => onInputChange(v, 'currency')}
								bg={'mainBg'}
								width={'100%'}
								hasIrt
							/>
							{input.isError && input.errorKey === 'currency' ? (
								<div className={'px-2'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs mt-[-8px]'} />
								</div>
							) : null}
						</div>

						<div className={'flex flex-col'}>
							<Text tid={'name'} className={'text-sm mx-1'} />
							<Background bg={'mainBg'} className={'mt-[-4px]'}>
								<Input
									value={input.name}
									onInputChange={(v) => onInputChange(v, 'name')}
									size={'small'}
									height={'40px'}
								/>
							</Background>
							{input.isError && input.errorKey === 'name' ? (
								<Text tid={input.errorMessage} className={'text-red-500 text-xs mt-[-8px] px-3'} />
							) : null}
						</div>
					</div>

					<div
						className={'px-3 py-3 w-full text-xs flex items-center justify-between dark:bg-cardBg'}
					>
						<Text tid={'currency-info'} />
					</div>

					<div className={'grid grid-cols-1 lg:grid-cols-2 gap-3 p-3'}>
						<Background bg={'mainBg'} className={'lg:mt-[-4px]'}>
							<Input
								value={input.min}
								onInputChange={(v) => onInputChange(v, 'min')}
								size={'small'}
								height={'40px'}
								label={'min-amount'}
								currency={input.currency?.id}
								number
							/>
							{input.isError && input.errorKey === 'min' ? (
								<div className={'px-2 mt-[-8px]'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
								</div>
							) : null}
						</Background>

						<Background bg={'mainBg'} className={'mt-[-12px] lg:mt-[-4px]'}>
							<Input
								value={input.max}
								onInputChange={(v) => onInputChange(v, 'max')}
								size={'small'}
								height={'40px'}
								label={'max-amount'}
								currency={input.currency?.id}
								number
							/>
							{input.isError && input.errorKey === 'max' ? (
								<div className={'px-2 mt-[-8px]'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
								</div>
							) : null}
						</Background>

						<Background bg={'mainBg'} className={'lg:mt-[-4px]'}>
							<Input
								value={input.feeMin}
								onInputChange={(v) => onInputChange(v, 'feeMin')}
								size={'small'}
								height={'40px'}
								label={'feeMin-amount'}
								currency={input.currency?.id}
								number
							/>
							{input.isError && input.errorKey === 'feeMin' ? (
								<div className={'px-2 mt-[-8px]'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
								</div>
							) : null}
						</Background>

						<Background bg={'mainBg'} className={'mt-[-12px] lg:mt-[-4px]'}>
							<Input
								value={input.feeMax}
								onInputChange={(v) => onInputChange(v, 'feeMax')}
								size={'small'}
								height={'40px'}
								label={'feeMax-amount'}
								currency={input.currency?.id}
								number
							/>
							{input.isError && input.errorKey === 'feeMax' ? (
								<div className={'px-2 mt-[-8px]'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
								</div>
							) : null}
						</Background>

						<Background bg={'mainBg'} className={'mt-[-12px] lg:mt-[-4px]'}>
							<Input
								value={input.feeFactor}
								onInputChange={(v) => onInputChange(v, 'feeFactor')}
								size={'small'}
								height={'40px'}
								label={'feeFactor-amount'}
								currency={input.currency?.id}
								number
							/>
							{input.isError && input.errorKey === 'feeFactor' ? (
								<div className={'px-2 mt-[-8px]'}>
									<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
								</div>
							) : null}
						</Background>
					</div>

					<div
						className={'px-3 py-3 w-full text-xs flex items-center justify-between dark:bg-cardBg'}
					>
						<Text tid={'fields-info'} />
						{input.isError && input.errorKey === 'fields' ? (
							<div className={'px-2 mt-[-8px]'}>
								<Text tid={input.errorMessage} className={'text-red-500 text-xs'} />
							</div>
						) : null}
					</div>

					{fieldMode.mode === 'close' ? (
						<div className={'grid lg:grid-cols-2 grid-cols-1 gap-3 p-3 lg:p-5'}>
							{input.fields.map((f, idx) => {
								return (
									<div key={f.id}>
										<div className={'rounded-md dark:bg-primaryBg text-[0.75rem]'}>
											<div
												className={`rounded-t-md ${typeColors[f.type]
													} h-[26px] w-full flex items-center justify-between px-3`}
											>
												<div className={'flex items-center gap-2'}>
													<span>{f.type}</span>
													{f.isRequired ? <span>*</span> : null}
												</div>
												<div className={'flex items-center gap-3'}>
													<div
														className={'cursor-pointer'}
														onClick={() => {
															setFieldMode({ mode: 'edit', idx })
															setFieldValues(f)
														}}
													>
														<FaEdit size={16} />
													</div>
													<div className={'cursor-pointer'} onClick={() => onDeleteField(idx)}>
														<FaTrash size={12} />
													</div>
												</div>
											</div>
											<div className='flex flex-col p-2'>
												<div className={'flex flex-col'}>
													<Text tid={'name-col'} />
													<span>{f.name}</span>
												</div>
												<div className={'h-[1px] w-full my-2 bg-slate-500/20'} />
												<div className={'flex flex-col'}>
													<Text tid={'description-col'} />
													<span>{f.description}</span>
												</div>
											</div>
										</div>
									</div>
								)
							})}

							<div
								onClick={() => setFieldMode({ mode: 'add' })}
								className={`border-[1px] border-dashed border-slate-500/20 
								h-[38px] rounded-md flex items-center justify-center cursor-pointer`}
							>
								<Text tid={'add-field'} />
							</div>
						</div>
					) : (
						<div className={'grid grid-cols-2 gap-x-2 lg:p-5 p-3'}>
							<Select
								options={fieldTypes}
								value={fieldValues.type}
								onValueChange={(x) =>
									setFieldValues((state) => ({ ...state, type: fieldTypes[x] }))
								}
								direction={'top'}
								height={'42px'}
								placeHolder={'select-type'}
								fontSize={'s'}
							/>
							<Background bg={'mainBg'} className={'mt-1'}>
								<Input
									value={fieldValues.name}
									onInputChange={(v) => setFieldValues((state) => ({ ...state, name: v }))}
									size={'small'}
									height={'40px'}
									label={'name'}
								/>
							</Background>
							<Background bg={'mainBg'}>
								<Input
									value={fieldValues.description}
									onInputChange={(v) => setFieldValues((state) => ({ ...state, description: v }))}
									size={'small'}
									height={'40px'}
									label={'description'}
								/>
							</Background>

							<div className={'flex items-center gap-2'}>
								<CheckBox
									active={fieldValues.isRequired}
									onClick={() =>
										setFieldValues((state) => ({ ...state, isRequired: !fieldValues.isRequired }))
									}
								/>
								<Text tid={'isRequired'} />
							</div>
							<div
								onClick={onChangeOrAddField}
								className={`mt-1 col-span-2 text-white rounded-md h-[42px] cursor-pointer 
									w-[50%] mx-auto bg-blue-500 flex items-center justify-center`}
							>
								<Text tid={`${fieldMode.mode}-field`} />
							</div>
						</div>
					)}
				</div>

				<div className={'flex flex-col gap-3 px-5 mt-5 mb-3'}>
					<div
						className={`bg-active text-slate-800 font-semibold rounded-md h-[40px]
                        w-full cursor-pointer flex items-center justify-center gap-2
                            `}
						onClick={onAddAccounting}
					>
						{loading ? <ClipLoader size={24} /> : null}
						<Text tid={`${isUpdate ? 'update' : 'add'}-accounting`} />
					</div>

					<div
						className={`border-red-500 border-opacity-20 border-[1px] cursor-pointer
                            font-semibold rounded-md h-[40px] w-full flex items-center justify-center
                            `}
						onClick={onClose}
					>
						<Text tid={'cancel'} />
					</div>
				</div>
			</div>
		</ModalLayout>
	)
}

export default AccountingModal
